export const JOURNEY_STAGES = [
  "Still dreaming / planning my first trip",
  "New nomad (< 1 year on the road)",
  "Established nomad (1+ years remote)",
  "Local to Nicaragua / Central America",
  "Business owner looking to collaborate",
];

export const LEAD_SKILLS = [
  "Marketing",
  "Visual Content · Photo · Video",
  "Travel Planning",
  "Sales",
  "Web & Tech",
  "Operations",
  "Teaching · Workshops",
  "Community Building",
];

export const LEAD_COLLAB = [
  "Commission-based project work",
  "Long-term partnership",
  "Short-term residency or workshop",
  "Mentorship — I want to learn",
  "I'm open — surprise me",
];

export const CONTACT_PREFS = ["Email", "WhatsApp", "Either works"];

export const APP_STAGES = [
  { value: "beginner", label: "Beginner" },
  { value: "exploring", label: "Exploring remote work" },
  { value: "already_remote", label: "Already remote" },
  { value: "remote_entrepreneur", label: "Remote entrepreneur" },
];

export const ADD_ONS = ["Website Architecture", "Google Ads Creation", "Custom System Creation", "All-in-One Systems Course"];

// Set to "/brand/hero.mp4" (and an optional smaller mobile file) once the video is added to public/brand
export const HERO_VIDEO = "/brand/hero-loop.mp4";
export const HERO_VIDEO_MOBILE = "/brand/hero-loop-mobile.mp4";

export const COURSE_FORMATS = [
  { value: "retreat_twin", label: "7-day retreat · Twin room · $1,190" },
  { value: "retreat_private", label: "7-day retreat · Private room · $1,470" },
  { value: "month_twin", label: "Stay the month at Esc · Twin room · $3,295" },
  { value: "month_private", label: "Stay the month at Esc · Private room · $3,750" },
  { value: "undecided", label: "Not sure yet" },
];

export const APP_SKILLS = [
  "Marketing",
  "Creative / visual work",
  "Travel planning",
  "Sales / partnerships",
  "Web / technology",
  "Operations",
  "Teaching",
  "Community building",
];

export const APP_COLLAB = [
  "Commission-based project work",
  "Long-term partnership",
  "Short-term residency or workshop",
  "Mentorship / learning",
  "Not sure yet",
];

export const DAY_STATUS = [
  { value: "not_started", label: "Not started" },
  { value: "in_class", label: "In class" },
  { value: "homework_submitted", label: "Homework submitted" },
  { value: "complete", label: "Complete" },
];

export const statusLabel = (v) => DAY_STATUS.find((s) => s.value === v)?.label || "Not started";

export const BEGINNER_PRICES = [
  { id: "twin", name: "Retreat · Twin room", price: "$1,190", note: "8 nights at Esc Digital Nomad Village in Popoyo, sharing a twin room." },
  { id: "private", name: "Retreat · Private room", price: "$1,470", note: "8 nights at Esc Digital Nomad Village in Popoyo, in your own private room." },
];

export const RETREAT_INCLUDES = [
  "8 nights at Esc Digital Nomad Village in a private or twin room", "Breakfast, lunch and dinner",
  "The full 7-day course, taught in person by Greg", "Esc membership",
  "1 group beginner surf lesson (board included)", "Daily yoga classes and gym access",
];

export const MONTHLY_PRICES = [
  { id: "month-twin", name: "Stay the month · Twin room", price: "$3,295" },
  { id: "month-private", name: "Stay the month · Private room", price: "$3,750" },
];

export const MONTHLY_INCLUDES = [
  "30 nights at Esc Digital Nomad Village in a private or twin room", "Breakfast, lunch and dinner",
  "The 7-day course with Greg, plus 3 build weeks with daily check-ins and coworking", "Esc membership",
  "1 group beginner surf lesson (board included)", "Daily yoga classes and gym access",
];

export const AI_COURSE_OUTCOME = "Every student or agency finishes the course with their own fully functional website or app — built by you, completely set up to generate leads.";

export const ESC_NOTE = "All in-person courses, retreats and classes are hosted at Esc Digital Nomad Village in Popoyo, Nicaragua.";

export const CURRICULUM = [
  { day: 1, title: "Welcome & map: your Freedom Number", result: "Your Break-even and Freedom Number, 5 skills, 3 circled income avenues, and your sealed Profile Questionnaire.", purpose: "Know yourself, know your number, and see all 11 ways to earn online once. Nobody quits their job because of this course." },
  { day: 2, title: "Sell your skills", result: "Greg's real success stories, a clear first offer, and a feel for which skill-selling path fits you.", purpose: "Avenues 1–3 — remote job, freelancing and virtual assistance: the fastest money online, using skills you already have." },
  { day: 3, title: "Teach & create", result: "A 60-second intro video and a draft tutor profile or coaching offer.", purpose: "Avenues 4–6 — online teaching, coaching & consulting, content & UGC: turn knowledge and personality into income." },
  { day: 4, title: "Build assets + money lab", result: "A monthly budget, your real runway number, and a multi-currency account started.", purpose: "Avenues 7–11 — blogging & affiliate, digital products, e-commerce, AI & automation, remote sales — plus the money lab." },
  { day: 5, title: "Test drive", result: "Your top 2 locked in and one small real-world test done for each.", purpose: "Lock in your top 2 avenues, then try the smallest real version of each and judge it on energy and response." },
  { day: 6, title: "Decide", result: "One chosen avenue, a completed Avenue Scorecard, a visa/insurance checklist and a weekly rhythm.", purpose: "Open your sealed questionnaire, score your two avenues honestly, choose one, and check the real requirements of working abroad." },
  { day: 7, title: "Commit & graduate", result: "A presented 90-day plan with decision gates, a recommended course, and an accountability partner.", purpose: "Present your plan, set continue / revise / delay / stop conditions, and leave with your first 48-hour action." },
];

export const HOST_EMAIL = "gregmiceli2018@gmail.com";
export const PUBLIC_EMAIL = "Greg@DigitalNomadNicaragua.com";
export const WHATSAPP_NUMBER = "50586156364";
export const PAYPAL_CLIENT_ID = "BAAaLFMOsj1OzGFkYv8OynVmE5ky0peapO_0QTgzohSVO1knhy2F1Gk4EU8DIv1T3KJCt4JNoj5ru3rHOY";
export const PAYPAL_BUTTON_ID = "NX86RCXNFFZUL";
export const PAYPAL_PACKAGE_BUTTONS = { retreat_twin: "", retreat_private: "" };
export const WHATSAPP_DISPLAY = "+505 8615 6364";

export const PRIVACY_NOTE =
  "Please do not enter sensitive financial, medical, or employment details. Ranges or fictional examples are perfectly fine.";
